export class CourseCategory {
    courseCategoryName: string;
    status: boolean;
    id: number;
}